import { Controller } from "@hotwired/stimulus";
import bootstrap from "bootstrap/dist/js/bootstrap";
import JobProcessingChannel from "../channels/job_processing_channel";

export default class extends Controller {
  static targets = ["progressBar", "message", "toast", "spinner"];

  connect() {
    this.fileId = this.data.get("file-id");
    this.initializeToast();
    this.subscribeToStatus();
  }
  

  initializeToast() {
    const toastElement = this.toastTarget.querySelector(".toast");
    if (toastElement) {
      this.bsToast = new bootstrap.Toast(toastElement, {
        autohide: false,
      });
    }
  }

  subscribeToStatus() {
    this.subscription = JobProcessingChannel.subscribe(this.fileId, {
      received: (data) => this.updateProgress(data),
      connected: () => {
        console.log("Channel connected");
      },
      disconnected: () => {
        console.log("Channel disconnected");
      },
    });
  }

  updateProgress(data) {
    if (this.toastTarget.classList.contains("d-none")) {
      this.toastTarget.classList.remove("d-none");
      if (this.bsToast) {
        this.bsToast.show();
      }
    }

    this.progressBarTarget.style.width = `${data.progress}%`;

    if (data.message && this.hasSpinnerTarget) {
      this.spinnerTarget.remove();
    }

    this.messageTarget.textContent = data.message;

    if (data.progress === 100) {
      this.progressBarTarget.classList.add("bg-success");
    }
  }

  hideToast() {
    this.progressBarTarget.classList.remove("bg-success");
    this.messageTarget.textContent = "";
    this.progressBarTarget.style.width = "0%";
    this.toastTarget.classList.add("d-none");

    this.safeUnsubscribe();
  }

  safeUnsubscribe() {
    try {
      if (this.subscription) {
        this.subscription.unsubscribe();
        this.subscription = null;
      }
    } catch (error) {
      console.error("Error unsubscribing:", error);
      this.subscription = null;
    }
  }

  disconnect() {
    this.safeUnsubscribe();
  }
}
